import { render, staticRenderFns } from "./RulesManagers.vue?vue&type=template&id=5ca0e570&scoped=true&"
import script from "./RulesManagers.vue?vue&type=script&lang=js&"
export * from "./RulesManagers.vue?vue&type=script&lang=js&"
import style0 from "./RulesManagers.vue?vue&type=style&index=0&id=5ca0e570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0e570",
  null
  
)

export default component.exports